import { GiftOutlined } from '@ant-design/icons';
import { useFeatureEntitlements } from '@frontegg/react';

const CelloWidgetSideMenu = ({ isActive }) => {
  const { isEntitled } = useFeatureEntitlements('referral-program');
  if (!isEntitled) {
    return [];
  }

  const menus = [
    {
      path: '/referral',
      title: 'Get $1000',
      icon: <GiftOutlined isFilled={isActive} />,
      dataCelloClick: false,
      celloClassName: 'celloClass relative',
      className: 'celloAnnouncement',
    },
  ];
  return menus;
};

export default CelloWidgetSideMenu;
